import { NotepadText } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CertificationParticipantsQuery } from "@/graphql";

export function IssuerCell({
  participant,
}: {
  participant: NonNullable<
    CertificationParticipantsQuery["certification"]
  >["participants"]["data"][number];
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <div>{participant.issuedBy.name}</div>
        {participant.note && (
          <Tooltip>
            <TooltipTrigger className="cursor-default">
              <NotepadText className="text-primary-700" size={16} />
            </TooltipTrigger>
            <TooltipContent>{participant.note}</TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
